'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ListOwner;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ListOwner(_ref) {
  var owner = _ref.owner;

  return _react2.default.createElement(
    'div',
    { className: 'cp-list-owner' },
    _react2.default.createElement(
      'div',
      { className: 'owner-name', 'data-test-id': 'owner-name' },
      _react2.default.createElement(_reactIntl.FormattedMessage, {
        id: 'user_list_by_user',
        values: { name: owner.get('name') } })
    ),
    _react2.default.createElement(
      'div',
      { className: 'library-name', 'data-test-id': 'library-name' },
      owner.get('libraryName')
    )
  );
}

ListOwner.propTypes = {
  owner: _reactImmutableProptypes2.default.contains({
    name: _react.PropTypes.string,
    libraryName: _react.PropTypes.string
  })
};


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/list-owner/components/ListOwner.component.js
// module id = 1313
// module chunks = 0